<template>
  <div class="sound_main">
    <div class="sound__header">
      <div class="sound__icon">&#57351;</div>
      <div class="sound__num">{{ num }}</div>
    </div>
    <div class="sound__content">{{ content }}</div>
    <div class="sound__doc" v-if="doc">
      <span v-html="'&#57351;'"></span>
      <div v-html="doc"></div>
    </div>
    <div class="sound__player" :autoplay="false">
      <div @click="togglePlayback">{{ playing ? "Pause" : "Play" }}</div>
    </div>
  </div>
</template>

<style scoped>
.sound_main {
  margin: 10px;
  width: calc(50% - 20px);
  color: #ffffff;
  background-color: #878787;
}

.sound_main > div {
  padding: 20px;
}

.sound__header {
  display: flex;
  justify-content: space-between;
}

.sound__header > div {
  width: 50%;
}

.sound__player {
  border-top: 1px solid #ffffff;
  text-transform: uppercase;
}

.sound__citation {
  border-top: 1px solid #ffffff;
  font-size: 10px;
}

.sound__citation span {
  margin-right: 20px;
}

@media screen and (max-width: 600px) {
  .sound__main {
    width: 100%;
  }
}
</style>

<script>
import VueHowler from "vue-howler";

export default {
  title: "Sound",
  props: {
    num: String,
    content: String,
    doc: String
  },
  mixins: [VueHowler]
};
</script>
